import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import { env } from "../../../env";
import { useParams } from "react-router-dom";

const CommonCategoryScrollFilter = ({ firstCategoryList, secondCategoryList, thirdCategoryList, sendSecondLevelCategoryList, sendThirdLevelCategoryList, filterSelected, sendFilterDataFromChild }) => {
    const {customerid} = useParams();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);
    const [selectedMasterCategories, setSelectedMasterCategories] = useState([]);

    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    const [showLeftArrow1, setShowLeftArrow1] = useState(false);
    const [showRightArrow1, setShowRightArrow1] = useState(true);
    const [showLeftArrow2, setShowLeftArrow2] = useState(false);
    const [showRightArrow2, setShowRightArrow2] = useState(true);

    const scrollContainerRef = useRef(null);
    const scrollContainerRef1 = useRef(null);
    const scrollContainerRef2 = useRef(null);

    const [secondLevelCategoryList, setSecondLevelCategoryList] = useState([]);
    const [thirdLevelCategoryList, setThirdLevelCategoryList] = useState([]);
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');

    useEffect(() => {
        if (filterSelected) {
            const categoryIds = filterSelected?.categoryIdArray
                ? String(filterSelected.categoryIdArray).split(',').map(Number)
                : [];

            const subcategoryIds = filterSelected?.subCategoryIdArray
                ? String(filterSelected.subCategoryIdArray).split(',').map(Number)
                : [];

            const mastercategoryIds = filterSelected?.masterCategoryIdArray
                ? String(filterSelected.masterCategoryIdArray).split(',').map(Number)
                : [];

            setSelectedCategories(categoryIds);
            setSelectedSubCategories(subcategoryIds);
            setSelectedMasterCategories(mastercategoryIds);
        }
    }, [filterSelected]);

    useEffect(() => {
        setSecondLevelCategoryList(secondCategoryList);
        setThirdLevelCategoryList(thirdCategoryList);
    }, [secondCategoryList, thirdCategoryList]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) container.addEventListener("scroll", handleScroll);
        return () => container?.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const container = scrollContainerRef1.current;
        if (container) container.addEventListener("scroll", handleScroll1);
        return () => container?.removeEventListener("scroll", handleScroll1);
    }, [secondLevelCategoryList]);

    useEffect(() => {
        const container = scrollContainerRef2.current;
        if (container) container.addEventListener("scroll", handleScroll2);
        return () => container?.removeEventListener("scroll", handleScroll2);
    }, [thirdLevelCategoryList]);

    useEffect(() => {
        handleScroll();
    }, [firstCategoryList]);

    useEffect(() => {
        handleScroll1();
    }, [secondLevelCategoryList]);

    useEffect(() => {
        handleScroll2();
    }, [thirdLevelCategoryList]);

    const handleScroll = () => {
        const container = scrollContainerRef.current;
        if (container) {
            const isAtStart = container.scrollLeft === 0;
            const isAtEnd = Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth;
            setShowLeftArrow(!isAtStart);
            setShowRightArrow(!isAtEnd);
        }
    };
    const handleScroll1 = () => {
        const container = scrollContainerRef1.current;
        if (container) {
            const isAtStart1 = container.scrollLeft === 0;
            const isAtEnd1 = Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth;
            setShowLeftArrow1(!isAtStart1);
            setShowRightArrow1(!isAtEnd1);
        }
    };
    const handleScroll2 = () => {
        const container = scrollContainerRef2.current;
        if (container) {
            const isAtStart2 = container.scrollLeft === 0;
            const isAtEnd2 = Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth;
            setShowLeftArrow2(!isAtStart2);
            setShowRightArrow2(!isAtEnd2);
        }
    };

    const handleScrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
            setTimeout(handleScroll, 300);
        }
    };
    const handleScrollRight1 = () => {
        if (scrollContainerRef1.current) {
            scrollContainerRef1.current.scrollBy({ left: 300, behavior: "smooth" });
            setTimeout(handleScroll1, 300);
        }
    };
    const handleScrollRight2 = () => {
        if (scrollContainerRef2.current) {
            scrollContainerRef2.current.scrollBy({ left: 300, behavior: "smooth" });
            setTimeout(handleScroll2, 300);
        }
    };

    const handleScrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
            setTimeout(handleScroll, 300);
        }
    };
    const handleScrollLeft1 = () => {
        if (scrollContainerRef1.current) {
            scrollContainerRef1.current.scrollBy({ left: -300, behavior: "smooth" });
            setTimeout(handleScroll1, 300);
        }
    };
    const handleScrollLeft2 = () => {
        if (scrollContainerRef2.current) {
            scrollContainerRef2.current.scrollBy({ left: -300, behavior: "smooth" });
            setTimeout(handleScroll2, 300);
        }
    };
    const getSecondLevelCategory = async (data) => {
        const headers = {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        };
    
        try {
            const response = await axios.get(
                `${baseUrl}/api/Product/GetSecondLevelCategoryForCommonItems?customerid=${customerid}&mastercategoryids=${data.categoryIds?.toString() || ""}`,
                { headers }
            );
    
            if (response.data) {
                setSecondLevelCategoryList(response.data);
                sendSecondLevelCategoryList(response.data);
    
                const validIds = new Set(response.data.map(item => item.mastercategoryid));
                const cleanedMasterCategories = selectedMasterCategories.filter(id => validIds.has(id));
                setSelectedMasterCategories(cleanedMasterCategories);
    
                return cleanedMasterCategories;
            }
        } catch (error) {
            console.log(error);
        }
    
        return [];
    };
    const getThirdLevelCategory = async (data) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };
    
        try {
            const response = await axios.get(
                baseUrl + `/api/Product/GetThirdLevelCategoryForCommonItems?customerid=${customerid}&categoryids=${data.categoryIds?.toString() || ""}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, 
                { headers }
            );
    
            if (response.data) {
                setThirdLevelCategoryList(response.data);
                sendThirdLevelCategoryList(response.data)
                
                const validIds1 = new Set(response.data.map(item => item.subcategoryid));
                const cleanedSubCategories = selectedSubCategories.filter(id => validIds1.has(id));
                setSelectedSubCategories(cleanedSubCategories);
    
                return cleanedSubCategories;
            }
        } catch (error) {
            console.log(error);
        }
    
        return []; // In case of error or no data
    };
    const handleFirstClick = async (event, value) => {
        const { categoryid: checkedId } = value;
        const isChecked = event.target.checked;
    
        const updatedCategoryIds = isChecked
            ? [...selectedCategories, checkedId]
            : selectedCategories.filter(id => id !== checkedId);
    
        setSelectedCategories(updatedCategoryIds);
        var data = await getSecondLevelCategory({categoryIds: updatedCategoryIds})
        var data1 = await getThirdLevelCategory({categoryIds: updatedCategoryIds, masterCategoryIds: data})
       
        sendFilterDataFromChild({
            type: 'common',
            categoryIds: updatedCategoryIds,
            masterCategoryIds: data,
            subCategoryIds: data1
        });
    };
    const handleSecondClick = async (mastercategoryid) => {
        const updatedMasterCategoryIds = selectedMasterCategories.includes(mastercategoryid)
            ? selectedMasterCategories.filter(id => id !== mastercategoryid)
            : [...selectedMasterCategories, mastercategoryid];

        setSelectedMasterCategories(updatedMasterCategoryIds)
        var data1 = await getThirdLevelCategory({categoryIds: selectedCategories, masterCategoryIds: updatedMasterCategoryIds})
    
        sendFilterDataFromChild({
            type: 'common',
            categoryIds: selectedCategories,
            masterCategoryIds: updatedMasterCategoryIds,
            subCategoryIds: data1
        });
    };
    const handleThirdClick = (subcategoryid) => {
        setSelectedSubCategories(prev => {
            const updated = prev.includes(subcategoryid)
                ? prev.filter(id => id !== subcategoryid)
                : [...prev, subcategoryid];

            sendFilterDataFromChild({
                type: 'common',
                categoryIds: selectedCategories,
                masterCategoryIds: selectedMasterCategories,
                subCategoryIds: updated
            });
            
            return updated;
        });
    };
    const handleCategoryClearFilter = async () => {
        // blank set value
        setSelectedCategories([]);
        setSelectedMasterCategories([]);
        setSelectedSubCategories([]);
        // blank list
        setSecondLevelCategoryList([]);
        setThirdLevelCategoryList([]);
        // send blank list
        sendSecondLevelCategoryList([]);
        sendThirdLevelCategoryList([]);

        sendFilterDataFromChild({type: 'common', categoryIds: [], masterCategoryIds: [], subCategoryIds: []});
    };
    const handleSubCategoryClearFilter = async () => {
        // blank set value
        setSelectedMasterCategories([]);
        setSelectedSubCategories([]);
        // blank list
        setThirdLevelCategoryList([]);
        // send blank list
        sendThirdLevelCategoryList([]);
        sendFilterDataFromChild({type: 'common', categoryIds: selectedCategories, masterCategoryIds: [], subCategoryIds: [] });
    };
    const handleMasterCategoryClearFilter = () => {
        setSelectedSubCategories([]);
        sendFilterDataFromChild({type: 'common',categoryIds: selectedCategories,  masterCategoryIds: selectedMasterCategories, subCategoryIds: []});
    };

    return (
        <div className="space-y-1 sm:space-y-2">
            {/* Categories */}
            <div className="flex items-center justify-start">
                {(selectedCategories.length > 0) ?
                    <img onClick={handleCategoryClearFilter} className="cursor-pointer" src={`../../../../assets/icons/table/red-filter.svg`} alt="clear filters" />
                    :
                    <img src={`../../../../assets/icons/table/blue-filter.svg`} alt="filters" />
                }

                {showLeftArrow ?
                        <img onClick={handleScrollLeft} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/left-arrow-active.svg" alt="left" />
                    :
                        <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/left-arrow-disable.svg" alt="left" />
                }

                <div ref={scrollContainerRef} className="flex overflow-x-scroll no-scrollbar gap-1 sm:gap-2 max-w-full text-[10px] sm:text-xs">
                    {firstCategoryList.map((category, index) => {
                        const isChecked = selectedCategories.includes(category.categoryid);
                        return (
                            <label
                                key={'cat' + index}
                                className={`flex items-center gap-1 px-2 sm:px-3 py-1 rounded-full cursor-pointer transition-all duration-200 border border-black-100 ${
                                isChecked ? "bg-blue-light" : "bg-white"
                                }`}
                            >
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(event) => handleFirstClick(event, category)}
                                    className="hidden"
                                />
                                <span className="flex w-max font-semibold">{category.categoryname}</span>
                            </label>
                        );
                    })}
                </div>

                {showRightArrow ?
                        <img onClick={handleScrollRight} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/right-arrow-active.svg" alt="right" />
                    :
                        <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/right-arrow-disable.svg" alt="right" />
                }
            </div>

            {/* Subcategories */}
            {secondLevelCategoryList.length > 0 && (
                <div className="flex items-center justify-start">
                    {(selectedMasterCategories.length > 0) ?
                        <img onClick={handleSubCategoryClearFilter} className="cursor-pointer" src={`../../../../assets/icons/table/red-filter.svg`} alt="filter" />
                        :
                        <img src={`../../../../assets/icons/table/blue-filter.svg`} alt="filter" />
                    }

                    {showLeftArrow1 ?
                            <img onClick={handleScrollLeft1} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/left-arrow-active.svg" alt="left" />
                        :
                            <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/left-arrow-disable.svg" alt="left" />
                    }

                    <div ref={scrollContainerRef1} className="flex overflow-x-scroll no-scrollbar gap-1 sm:gap-2 max-w-full text-[10px] sm:text-xs">
                        {secondLevelCategoryList.map((subcat, index1) => (
                            <div
                                key={'subcat' + index1}
                                onClick={() => handleSecondClick(subcat.mastercategoryid)}
                                className={`${selectedMasterCategories.includes(subcat.mastercategoryid) ? "bg-blue-light" : "bg-white"} px-2 sm:px-3 py-1 rounded-full cursor-pointer transition-all duration-200 border border-black-100`}>
                                <span className="flex w-max font-semibold">{subcat.mastercategoryname}</span>
                            </div>
                        ))}
                    </div>

                    {showRightArrow1 ?
                            <img onClick={handleScrollRight1} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/right-arrow-active.svg" alt="right" />
                        :
                            <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/right-arrow-disable.svg" alt="right" />
                    }
                </div>
            )}

            {/* mastercategories */}
            {thirdLevelCategoryList.length > 0 && (
                <div className="flex items-center justify-start">
                    {(selectedSubCategories.length > 0) ?
                        <img onClick={handleMasterCategoryClearFilter} className="cursor-pointer" src={`../../../../assets/icons/table/red-filter.svg`} alt="filter" />
                        :
                        <img src={`../../../../assets/icons/table/blue-filter.svg`} alt="filter" />
                    }

                    {showLeftArrow2 ?
                            <img onClick={handleScrollLeft2} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/left-arrow-active.svg" alt="left" />
                        :
                            <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/left-arrow-disable.svg" alt="left" />
                    }

                    <div ref={scrollContainerRef2} className="flex overflow-x-scroll no-scrollbar gap-1 sm:gap-2 max-w-full text-[10px] sm:text-xs">
                        {thirdLevelCategoryList.map((master, index1) => (
                            <div
                                key={'master' + index1}
                                onClick={() => handleThirdClick(master.subcategoryid)}
                                className={`${selectedSubCategories.includes(master.subcategoryid) ? "bg-blue-light" : "bg-white"} px-2 sm:px-3 py-1 rounded-full cursor-pointer transition-all duration-200 border border-black-100`}>
                                <span className="flex w-max font-semibold">{master.subcategoryname}</span>
                            </div>
                        ))}
                    </div>

                    {showRightArrow2 ?
                            <img onClick={handleScrollRight2} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/right-arrow-active.svg" alt="right" />
                        :
                            <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/right-arrow-disable.svg" alt="right" />
                    }
                </div>
            )}
        </div>
    );
};

export default CommonCategoryScrollFilter;
